module.exports = __webpack_public_path__ + "img/timetable-cloud.4593801b.png";